import { useFetch } from "../hooks/useFetch";
import { getTimeline } from "../services/firestore";
import SEO from "../components/ui/SEO";
import Timeline from "../components/sections/Timeline";

export default function TimelinePage() {
  const { data: timelineEntries, loading } = useFetch(getTimeline, []);

  return (
    <main className="timeline-page" aria-label="Main content">
      <SEO
        title="Timeline"
        description="Academic and professional journey of Rajat Shenoi."
        url="/timeline"
      />
      <Timeline entries={timelineEntries || []} loading={loading} />
    </main>
  );
}
